import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react'
import { get } from '../api/client'
import { useRoseWallet } from '../wallet/useRoseWallet'

const SessionContext = createContext(null)
const empty = { loading: true, authenticated: false, isAdmin: false, wallets: [], adminWalletAddress: null }

export function SessionProvider({ children }) {
  const { solana } = useRoseWallet()
  const [session, setSession] = useState(empty)
  const [modules, setModules] = useState([])

  const refreshSession = useCallback(async () => {
    setSession(value => ({ ...value, loading: true }))
    try {
      const headers = solana.address ? { 'X-Rose-Wallet-Address': solana.address } : {}
      const value = await get('/api/v1/platform/session', { headers })
      setSession({ ...value, loading: false })
    } catch {
      setSession({ ...empty, loading: false })
    }
  }, [solana.address])

  const refreshModules = useCallback(async () => {
    try { setModules((await get('/api/v1/platform/modules')).modules || []) } catch { setModules([]) }
  }, [])

  useEffect(() => { refreshSession() }, [refreshSession])
  useEffect(() => { refreshModules() }, [refreshModules])
  useEffect(() => {
    const sessionHandler = () => refreshSession()
    const modulesHandler = () => refreshModules()
    window.addEventListener('rose:session-changed', sessionHandler)
    window.addEventListener('rose:modules-changed', modulesHandler)
    return () => {
      window.removeEventListener('rose:session-changed', sessionHandler)
      window.removeEventListener('rose:modules-changed', modulesHandler)
    }
  }, [refreshSession, refreshModules])

  const isAdmin = Boolean(session.authenticated && solana.address && session.isAdmin && session.adminWalletAddress && session.adminWalletAddress.toLowerCase() === solana.address.toLowerCase())
  const moduleMap = useMemo(() => Object.fromEntries(modules.map(item => [item.module_key, item])), [modules])
  const value = useMemo(() => ({ session, modules, moduleMap, isAdmin, refreshSession, refreshModules }), [session, modules, moduleMap, isAdmin, refreshSession, refreshModules])
  return <SessionContext.Provider value={value}>{children}</SessionContext.Provider>
}

export const useRoseSession = () => useContext(SessionContext)
